import { createContext, useContext } from 'react';
export const EmbeddedContext = /*#__PURE__*/createContext({
  isInsideMarketingStudio: false
});
export const useEmbeddedEditorContext = () => {
  try {
    return useContext(EmbeddedContext);
  } catch (error) {
    console.error('useEmbeddedContext must be used within an EmbeddedContext');
    return {
      isInsideMarketingStudio: false
    };
  }
};